"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DonationSocketEvent = void 0;
var DonationSocketEvent;
(function (DonationSocketEvent) {
    DonationSocketEvent["JoinRoom"] = "donation:joinRoom";
    DonationSocketEvent["LeaveRoom"] = "donation:leaveRoom";
    DonationSocketEvent["Received"] = "donation:received";
})(DonationSocketEvent || (exports.DonationSocketEvent = DonationSocketEvent = {}));
